import type { FlightLeg } from "./types";

function n(v: number | null | undefined): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return "";
  return String(Math.round(v * 1e4) / 1e4);
}

/**
 * Fingerprint for spotting duplicate rows (e.g. CSV imported twice into Supabase).
 * Same date/route/operating snapshot → one leg kept (first in input order).
 */
export function flightLegFingerprint(leg: FlightLeg): string {
  return [
    leg.flightDate,
    leg.fromIcao.trim().toUpperCase(),
    leg.toIcao.trim().toUpperCase(),
    n(leg.tachStart),
    n(leg.tachEnd),
    n(leg.flightHours),
    n(leg.fuelLbs),
    n(leg.fuelGallonsReported),
    String(Math.max(0, leg.passengerCount)),
    (leg.crewList ?? "").trim(),
    (leg.passengerList ?? "").trim(),
    n(leg.landings),
    n(leg.takeoffs),
    leg.excludeFrom720 ? "1" : "0",
    leg.personalUse ? "1" : "0",
  ].join("|");
}

/** Drop duplicate fingerprints; keeps the first occurrence (stable). */
export function dedupeFlightLegs(legs: FlightLeg[]): FlightLeg[] {
  const seen = new Set<string>();
  const out: FlightLeg[] = [];
  for (const leg of legs) {
    const k = flightLegFingerprint(leg);
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(leg);
  }
  return out;
}
